var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuja1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_14834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4636 21.3641C16.3666 23.1428 16.1002 23.39 15.1774 24.1848C14.5012 23.6048 13.921 23.0772 11.4619 21.0149C6.94836 17.225 3.68728 14.4886 3.68728 10.4464C3.68728 6.61441 6.50226 3.61292 10.0958 3.61292C12.5097 3.61292 14.1114 4.97487 15.117 6.36202C16.0694 4.97066 17.6179 3.61292 20.0387 3.61292C23.6322 3.61292 26.4458 6.61451 26.4458 10.4464C26.4459 14.591 23.2703 17.2854 18.4636 21.3641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4636 21.3641C16.3666 23.1428 16.1002 23.39 15.1774 24.1848C14.5012 23.6048 13.921 23.0772 11.4619 21.0149C6.94836 17.225 3.68728 14.4886 3.68728 10.4464C3.68728 6.61441 6.50226 3.61292 10.0958 3.61292C12.5097 3.61292 14.1114 4.97487 15.117 6.36202C16.0694 4.97066 17.6179 3.61292 20.0387 3.61292C23.6322 3.61292 26.4458 6.61451 26.4458 10.4464C26.4459 14.591 23.2703 17.2854 18.4636 21.3641Z",
    fill: "url(#paint0_linear_240_14834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5281 44.9773C37.7651 42.4208 33.6478 41.444 29.1666 42.1909L21.9853 43.4261C19.2276 43.8858 16.7 43.7421 14.5169 43.024C10.0005 41.5188 5.47923 36.7782 4.281 34.9809C2.61484 32.4818 1.69956 29.7529 1.12496 28.4316C0.579182 27.1677 0.579182 26.2773 1.15369 25.7602C1.81446 25.1569 2.93465 25.4728 3.76778 25.9325C5.08904 26.6794 6.49284 28.8338 7.92911 30.9019C9.79615 33.6021 12.9942 35.2107 16.269 35.2107H26.6676V32.3382H22.3588C14.718 32.3382 11.2997 30.9019 11.2997 29.4657C11.2997 28.2593 13.6838 27.7134 14.4882 27.5412C17.6192 26.823 24.6857 26.4783 29.5114 24.3239C30.3817 23.9431 31.3683 23.7294 32.4125 23.7206C34.0496 23.7067 35.8289 24.2168 37.5259 25.5303C37.5544 25.5303 37.5544 25.5303 37.5832 25.559C38.7035 26.4208 40.2355 27.6847 42.3037 29.4944C44.0561 31.0454 45.7508 33.0275 48.7095 35.5554L49.7437 36.4459L42.6772 45.753L41.5281 44.9773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5281 44.9773C37.7651 42.4208 33.6478 41.444 29.1666 42.1909L21.9853 43.4261C19.2276 43.8858 16.7 43.7421 14.5169 43.024C10.0005 41.5188 5.47923 36.7782 4.281 34.9809C2.61484 32.4818 1.69956 29.7529 1.12496 28.4316C0.579182 27.1677 0.579182 26.2773 1.15369 25.7602C1.81446 25.1569 2.93465 25.4728 3.76778 25.9325C5.08904 26.6794 6.49284 28.8338 7.92911 30.9019C9.79615 33.6021 12.9942 35.2107 16.269 35.2107H26.6676V32.3382H22.3588C14.718 32.3382 11.2997 30.9019 11.2997 29.4657C11.2997 28.2593 13.6838 27.7134 14.4882 27.5412C17.6192 26.823 24.6857 26.4783 29.5114 24.3239C30.3817 23.9431 31.3683 23.7294 32.4125 23.7206C34.0496 23.7067 35.8289 24.2168 37.5259 25.5303C37.5544 25.5303 37.5544 25.5303 37.5832 25.559C38.7035 26.4208 40.2355 27.6847 42.3037 29.4944C44.0561 31.0454 45.7508 33.0275 48.7095 35.5554L49.7437 36.4459L42.6772 45.753L41.5281 44.9773Z",
    fill: "url(#paint1_linear_240_14834)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_14834",
    x1: 4.3897,
    y1: 39.0203,
    x2: 31.6835,
    y2: 35.7002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_14834",
    x1: 2.23225,
    y1: 61.6419,
    x2: 58.5267,
    y2: 47.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_14834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.0244,
    height: 49.0244,
    fill: "white",
    transform: "matrix(-1 0 0 1 49.7437 0.170776)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuja1);
export default __webpack_public_path__ + "static/media/puja-1.f7b94df7c7c165d68dc254d17e6f122d.svg";
export { ForwardRef as ReactComponent };